import React, {useEffect} from 'react';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {PaymentApi, PaymentDto, PaymentGood, PaymentStatus, UserApi, UserDto} from '../../scaffold';
import {useAntdTable} from 'ahooks';
import AntDTableUtils from '../../utils/AntDTableUtils';
import {DefaultAntdTableConfig} from '../../utils/CommonConfig';
import {Button, Card, Popover, Select, Space, Table} from 'antd';
import moment from 'moment/moment';
import UserViewBtn from '../../components/user/ViewBtn';
import UserEditBtn from '../../components/user/EditBtn';
import {QRCodeSVG} from 'qrcode.react';
import {CSVLink} from 'react-csv';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function ManagePaymentList() {
  const searchHook = useOpenApiFpRequest(PaymentApi, PaymentApi.prototype.paymentSearchGet);
  const searchAllHook = useOpenApiFpRequest(PaymentApi, PaymentApi.prototype.paymentSearchGet);
  const [paymentGood, setPaymentGood] = React.useState<PaymentGood>();
  const [status, setStatus] = React.useState<PaymentStatus>();
  useEffect(() => {
    searchAllHook
      .request({pi: 1, ps: 99999})
      .then()
      .catch(CommonApiErrorHandler);
  }, []);
  const antdConfig = useAntdTable(
    params => {
      return searchHook.request({
        ...AntDTableUtils.makeParams(params),
        paymentGood,
        paymentStatus: status,
      });
    },
    {...DefaultAntdTableConfig, refreshDeps: [paymentGood, status]},
  );
  const headers = [
    {label: '商户订单号', key: 'outTradeNumber'},
    {label: '会员姓名', key: 'user.personalApprove.name'},
    {label: '会员手机号', key: 'user.telephone'},
    {label: '缴费选项', key: 'paymentGood'},
    {label: '金额', key: 'price'},
    {label: '支付状态', key: 'status'},
    {label: '支付时间', key: 'paidTime'},
  ];
  return (
    <div className={'p-20'}>
      <Card
        title={'支付订单列表'}
        extra={
          searchAllHook.data?.list && (
            <Space>
              <Select value={status} onChange={setStatus} style={{width: 150}} allowClear placeholder={'筛选支付状态'}>
                <Select.Option value={PaymentStatus.未支付}>{PaymentStatus.未支付}</Select.Option>
                <Select.Option value={PaymentStatus.已关闭}>{PaymentStatus.已关闭}</Select.Option>
                <Select.Option value={PaymentStatus.已支付}>{PaymentStatus.已支付}</Select.Option>
                <Select.Option value={PaymentStatus.已退款}>{PaymentStatus.已退款}</Select.Option>
              </Select>
              <Select value={paymentGood} onChange={setPaymentGood} style={{width: 200}} allowClear placeholder={'筛选支付选项'}>
                <Select.Option value={PaymentGood.一年}>{PaymentGood.一年}</Select.Option>
                <Select.Option value={PaymentGood.二年}>{PaymentGood.二年}</Select.Option>
                <Select.Option value={PaymentGood.三年}>{PaymentGood.三年}</Select.Option>
                <Select.Option value={PaymentGood.四年}>{PaymentGood.四年}</Select.Option>
                <Select.Option value={PaymentGood.五年}>{PaymentGood.五年}</Select.Option>
                <Select.Option value={PaymentGood.永久}>{PaymentGood.永久}</Select.Option>
                <Select.Option value={PaymentGood.学生会员一年}>{PaymentGood.学生会员一年}</Select.Option>
                <Select.Option value={PaymentGood.双选会员一年}>{PaymentGood.双选会员一年}</Select.Option>
              </Select>
              <CSVLink data={searchAllHook.data?.list} headers={headers}>
                <Button>导出 Csv</Button>
              </CSVLink>
            </Space>
          )
        }>
        <Table {...antdConfig.tableProps} pagination={{...antdConfig.tableProps.pagination, showTotal: v => `共 ${v} 条`}} size={'small'} bordered>
          <Table.Column title={'ID'} dataIndex={'id'} sorter key={'id'} />
          <Table.Column<PaymentDto> title={'商户订单号'} render={(_, i) => i.outTradeNumber} />
          <Table.Column<PaymentDto> title={'会员姓名'} render={(_, i) => i.user?.personalApprove?.name} />
          <Table.Column<PaymentDto> title={'缴费选项'} render={(_, i) => i.paymentGood} />
          <Table.Column<PaymentDto>
            title={'支付状态'}
            render={(_, i) => {
              return i.status;
            }}
          />
          <Table.Column<PaymentDto> title={'支付时间'} render={(_, i) => i.paidTime} />
          <Table.Column<PaymentDto> title={'创建时间'} render={(_, i) => i.createdTime} />
        </Table>
      </Card>
    </div>
  );
}
